module.exports = __webpack_public_path__ + "img/pwa-notifications-mobile-standalone.0a180b35.png";